/**
 * PostgREST select strings for suppliers.
 * Intentionally omits `embedding` (vector) — including it bloats each page to tens of MB.
 * Heavy narrative fields (methodology, long recommendations) are omitted from list/roster
 * selects so paging ~2k rows does not hit statement timeouts.
 */

/** Columns needed for Early Signals roster UIs (dashboard, matrix list, KPIs). */
export const SUPPLIER_LIST_SELECT = [
  'id',
  'company_id',
  'name',
  'location',
  'risk_rating',
  'industry',
  'risk_scores',
  'overall_score',
  'outlook',
  'actions',
  'key_takeaways',
  'supplier_unique_id',
  'kenvue_region',
  'brand',
  'single_source',
  'category',
  'sub_category',
  'risk_gauge',
  'highest_risk_areas',
  'risk_outlook',
  'risk_outlook_6m',
  'risk_outlook_12m',
  'questions_to_ask',
  'risk_dimension_narratives',
  'spend_k',
  'dm_em',
  'procurement_type',
  'parent_name',
  'created_at',
  'updated_at',
].join(',')

/**
 * Slimmer select for Risk Analyst list/count/group tools.
 * Single-supplier profile/heatmap still fetches narratives via name resolve.
 */
export const SUPPLIER_RA_LIST_SELECT = [
  'id',
  'name',
  'location',
  'kenvue_region',
  'category',
  'sub_category',
  'industry',
  'brand',
  'single_source',
  'overall_score',
  'risk_gauge',
  'risk_scores',
  'supplier_unique_id',
  'procurement_type',
  'spend_k',
  'parent_name',
  'dm_em',
].join(',')

/** Full row for single-supplier profile / admin edit (not for paged roster). */
export const SUPPLIER_DETAIL_SELECT = [
  SUPPLIER_LIST_SELECT,
  'revenue',
  'growth',
  'employees',
  'years_in_business',
  'lead_time_days',
  'sla_pct',
  'quality_pct',
  'months_to_contract_expiry',
  'invoices',
  'support',
  'penalties_clause',
  'auto_renew',
  'stakeholder_score',
  'website',
  'ownership',
  'plant_code',
  'plant_desc',
  'recommendations',
  'methodology',
  'assessment_file_name',
  'report_title',
].join(',')
